module.exports = __webpack_public_path__ + "static/looka-69211cc61e3a9bdcd62081625eb3b8a8.png";